import { render, staticRenderFns } from "./activesession.vue?vue&type=template&id=2f28f42b&scoped=true"
import script from "./activesession.vue?vue&type=script&lang=js"
export * from "./activesession.vue?vue&type=script&lang=js"
import style0 from "./activesession.vue?vue&type=style&index=0&id=2f28f42b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f28f42b",
  null
  
)

export default component.exports